"use client";
import { cn } from "@lib/utils";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, VariantProps } from "class-variance-authority";
import { ComponentPropsWithoutRef, ComponentRef, Ref } from "react";

const labelVariants = cva("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");

const Label = ({
	ref,
	className,
	...props
}: ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
	VariantProps<typeof labelVariants> & {
		ref?: Ref<ComponentRef<typeof LabelPrimitive.Root>>;
	}) => <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />;
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
